import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import {
  ApiKey,
  ApiUrl,
  TransactionType,
  BankingChannel,
  PanelType,
} from "../../util/Constant";
import { stringIsNullOrEmpty, createMultiPartFormBody } from "../../util/Util";
import ApiEngine from "../../util/ApiEngine";
import { useForm, Controller } from "react-hook-form";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import Dropzone from "react-dropzone";
import { useDispatch } from "react-redux";
import { setBusy, setIdle, showResponseMessage } from "../../redux/AppAction";
import { Modal, ModalBody } from "reactstrap";
import { useLongPress } from "use-long-press";

const TNGDeposit = (props) => {
  const { t } = useTranslation();
  let _dispatch = useDispatch();
  const {
    handleSubmit,
    register,
    control,
    watch,
    setValue,
    getValues,
    errors,
    reset,
  } = useForm();
  const [bankOption, setBankOption] = useState([]);
  const [bankAccountOption, setBankAccountOption] = useState([]);
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [receiptImage, setReceiptImage] = useState();
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(0);
  const [isReloadSuccess, setIsReloadSuccess] = useState(false);
  const [paidAmount, setPaidAmount] = useState(0);
  const [reloadDate, setReloadDate] = useState();
  const [transcactionNumber, setTranscactionNumber] = useState();
  const [currentInput, setCurrentInput] = useState();
  const [canDisplayBank, setCanDisplayBank] = useState(false);
  const [userVipLevel, setUserVipLevel] = useState(0);
  const [tngImg, setTngImg] = useState("");
  const [depositReference, setDepositReference] = useState("");

  useEffect(() => {
    init();
  }, []);

  async function init() {
    let responseJson = await ApiEngine.get(
      ApiUrl._API_GET_USER_BANK + "?type=TNG"
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let bankList = [];
      responseJson[ApiKey._API_DATA_KEY].forEach(function (bank) {
        setValue("bankId", bank.id);
        bankList.push({
          label: bank.bankName,
          value: bank.id,
          min: bank.minimumDeposit,
          max: bank.maximumDeposit,
        });
        //setTngImg(bank.img);
      });
      let apiUrl = ApiUrl._API_GET_USER_SYSTEM_SETTINGS + "?type=DailyQR";
      let TnGJson = await ApiEngine.get(apiUrl);
      if (
        TnGJson[ApiKey._API_SUCCESS_KEY] &&
        TnGJson[ApiKey._API_DATA_KEY] != null
      ) {
        let data = TnGJson[ApiKey._API_DATA_KEY];
        setTngImg(data);
      }
      getBankAccountByBankId();
      setBankOption(bankList);
    }

    responseJson = await ApiEngine.get(
      ApiUrl._API_CHECK_DISPLAY_BANK_DETAIL
    ).then((response) => {
      setCanDisplayBank(response[ApiKey._API_SUCCESS_KEY]);
    });
    responseJson = await ApiEngine.get(ApiUrl._API_GET_USER_VIP_LEVEL);
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      setUserVipLevel(responseJson[ApiKey._API_DATA_KEY]);
    }

    let apiUrl = ApiUrl._API_GET_USER_SYSTEM_SETTINGS + "?type=depositReference";
    let settingJson = await ApiEngine.get(apiUrl);
    if (settingJson[ApiKey._API_SUCCESS_KEY] && settingJson[ApiKey._API_DATA_KEY] != null) {
      let data = settingJson[ApiKey._API_DATA_KEY];
      setDepositReference(data);
    }
  }

  async function getBankAccountByBankId() {
    let responseJson = await ApiEngine.get(
      ApiUrl._API_GET_BANK_ACCOUNT_BY_BANK_ID +
        "?bankId=" +
        watch("bankId") +
        "&deposit=" +
        true
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let bankAccountList = [];
      responseJson[ApiKey._API_DATA_KEY].forEach(function (bankAccount) {
        setValue("bankAccountId", bankAccount.id);
        setMinMax({
          min: bankAccount.minimumDeposit,
          max: bankAccount.maximumDeposit,
        });
        bankAccountList.push({
          label: bankAccount.accountHolderName,
          value: bankAccount.id,
          accNumber: bankAccount.accountNumber,
          min: bankAccount.minimumDeposit,
          max: bankAccount.maximumDeposit,
        });
      });

      setBankAccountOption(bankAccountList);
    }
  }

  useEffect(() => {
    if (!stringIsNullOrEmpty(watch("bankId"))) {
      setValue("bankAccountId", null);
      setBankAccountNumber("");
      getBankAccountByBankId();
    }
  }, [watch("bankId")]);

  const imageDrop = (acceptedFiles) => {
    if (acceptedFiles.length !== 0) {
      const file = acceptedFiles[0];
      setValue("receipt", file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setReceiptImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const remove = () => {
    setReceiptImage("");
    setValue("receipt", null);
  };

  function resetFormField() {
    setBankAccountNumber("");
    setBankAccountOption([]);
    setValue("bankId", "");
    setValue("bankAccountId", "");
    setValue("receipt", null);
    setReceiptImage("");
    setValue("depositDateTime", moment().format("YYYY-MM-DD HH:mm:ss"));
  }

  function setMinMax(e) {
    setMin(e.min);
    setMax(e.max);
  }

  async function onSubmit(data, e) {
    _dispatch(setBusy());
    let params = {
      transactionTypeId: TransactionType._DEPOSIT,
      amount: data.amount,
      channel: BankingChannel._CHANNEL_OFFLINE_BANKING,
      panel: PanelType._MEMBERSITE,
      bankAccountId: data.bankAccountId,
      receiptReference: "TNG: " + data.reference,
      //transactionDateTime: data.depositDateTime,
    };

    params["receipt"] = data.receipt;
    if (!stringIsNullOrEmpty(data.receipt)) {
    }
    let responseJson = await ApiEngine.post(
      ApiUrl._API_CREATE_TRANSACTION,
      createMultiPartFormBody(params)
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      setPaidAmount(params.amount);
      setIsReloadSuccess(true);
      setReloadDate(moment().format("DD MMM YYYY, hh:mm A"));
      setTranscactionNumber(responseJson[ApiKey._API_DATA_KEY]);
      //props.setTriggerParentInit(true);
      e.target.reset();
      resetFormField();
    } else {
      _dispatch(
        showResponseMessage(
          responseJson[ApiKey._API_SUCCESS_KEY],
          responseJson[ApiKey._API_MESSAGE_KEY]
        )
      );
    }
    _dispatch(setIdle());
  }

  const handleModalOnClick = () => {
    setIsReloadSuccess(false);
    props.parentInit();
  };

  const bindLongPressEvents = useLongPress(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: "download",
          url: tngImg,
        })
      );
    }
  });

  return (
    <>
      <form id="tngdeposit" onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group m-b-15" style={{ display: "none" }}>
            <label className="col-form-label">
              <b>{t("BANK")}</b>
            </label>
            <div>
              <Controller
                control={control}
                name="bankId"
                defaultValue={""}
              />
            </div>
          </div>

          <div className="form-group m-b-15" style={{ display: "none" }}>
              <label className="col-form-label">
                <b>{t("BANK_ACCOUNT")}</b>
              </label>
              <div>
                <Controller
                  control={control}
                  name="bankAccountId"
                  defaultValue={""}
                />
              </div>
            </div>

        {!stringIsNullOrEmpty(getValues("bankId")) && (
          <>
            <div className="form-group m-b-15 text-center pt-4">
              <img src={tngImg} width="50%" />
            </div>

            <div className="form-group m-b-15 text-center">
              <a
                href="https://youtu.be/ertSjk2cF7g"
                target="_blank"
                style={{ textDecoration: "underline" }}
              >
                {t("HOW_TO_TNG")}
              </a>
            </div>{" "}
          </>
        )}

        <div className="form-group m-b-15">
          <label className="font-15 text-white font-semi mb-3">
            {t("AMOUNT")}
          </label>
          <div>
            <input
              type="text"
              className="form-white-input"
              placeholder={t("PLEASE_ENTER_AMOUNT")}
              name="amount"
              onClick={(e) => {
                setCurrentInput(e.target);
              }}
              ref={register({
                required: "PLEASE_ENTER_AMOUNT",
                validate: {
                  minValue: (value) =>
                    (!canDisplayBank
                      ? value >= min
                      : parseFloat(value) > 0 && value >= min) ||
                    "VALUE_LESS_THAN_MINIMUM",
                  maxValue: (value) =>
                    (!canDisplayBank ? true : parseFloat(value) <= max) ||
                    "EXCEED_MAXIMUM_VALUE",
                },
                pattern: {
                  value: /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,3})?$/,
                  message:
                    "INVALID_AMOUNT",
                },
              })}
            />
            {errors.amount && (
              <div className="invalid-feedback">{t(errors.amount.message)}</div>
            )}
            {min != 0 && max != 0 && (
              <div className="col-md-12 font-11 amount-reminder ml-0">
                <span className="reminder">
                  * {t("MIN")} : {min}/ {t("MAX")} : {max}
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="form-group m-b-15">
          <label className="font-15 text-white font-semi mb-3">
            <b>{t("RECEIPT_REFERENCE")}</b>
          </label>
          <div>
            <input
              type="text"
              className="form-control"
              name="reference"
              value={depositReference}
              placeholder={depositReference}
              disabled
              style={{ fontSize: "14px", color: "#002e6c", fontWeight: "bold" }}
            />
            {errors.reference && (
              <div className="invalid-feedback">
                {t(errors.reference.message)}
              </div>
            )}
          </div>
        </div>
        {/*<div className="form-group m-b-15">
          <label className="font-15 text-white font-semi mb-3">
            {t("DEPOSIT_DATE_TIME")}
          </label>
          <div>
            <Controller
              control={control}
              name="depositDateTime"
              defaultValue={""}
              rules={{ required: "FIELD_REQUIRED" }}
              render={({ onChange, value }) => {
                return (
                  <DateRangePicker
                    containerStyles={{
                      width: "100%",
                    }}
                    timePicker={true}
                    singleDatePicker={true}
                    timePickerSeconds={true}
                    locale={{ format: "YYYY-MM-DD HH:mm:ss" }}
                    onApply={(event, picker) => {
                      onChange(
                        moment(picker.startDate).format("YYYY-MM-DD HH:mm:ss")
                      );
                    }}
                  >
                    <input
                      type="text"
                      className="form-white-input"
                      defaultValue={value}
                    />
                  </DateRangePicker>
                );
              }}
            />
            {errors.depositDateTime && (
              <div className="invalid-feedback">
                {t(errors.depositDateTime.message)}
              </div>
            )}
          </div>
        </div>*/}
        <div className="form-group m-b-15">
          <label className="font-15 text-white font-semi mb-3">
            {t("RECEIPT")}
          </label>
          <div>
            <Controller
              control={control}
              name="receipt"
              defaultValue={""}
              render={({ onChange, value }) => {
                return (
                  <Dropzone
                    accept={"image/*"}
                    onDrop={(acceptedFiles) => imageDrop(acceptedFiles)}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <section style={{ position: "relative" }}>
                        {!stringIsNullOrEmpty(receiptImage) && (
                          <div
                            style={{
                              background: "transparent",
                              padding: "5px 10px",
                              textAlign: "center",
                              position: "absolute",
                              right: "5px",
                              top: "5px",
                            }}
                            onClick={() => remove()}
                          >
                            <i className="fa fa-trash text-red"></i>
                          </div>
                        )}
                        <div
                          className="dropzone"
                          style={{ minHeight: "200px", textAlign: "center" }}
                          {...getRootProps()}
                        >
                          <input {...getInputProps()} />
                          <h4 style={{ color: "grey" }}>
                            {t(
                              "DRAG_N_DROP_SOME_FILES_HERE_OR_CLICK_TO_SELECT_FILES"
                            )}
                          </h4>
                          {!stringIsNullOrEmpty(receiptImage) && (
                            <aside className="thumbsContainer">
                              <div className="thumb">
                                <div className="thumbInner">
                                  <img
                                    src={receiptImage}
                                    className="dropzone-img"
                                  />
                                </div>
                              </div>
                            </aside>
                          )}
                        </div>
                      </section>
                    )}
                  </Dropzone>
                );
              }}
            />
          </div>
        </div>
        <div className="form-group mt-3 col-md-12 px-0">
          <button type="submit" className="custom-btn-style-1">
            {t("SUBMIT")}
          </button>
        </div>
      </form>
      <Modal
        fade={false}
        contentClassName="modal-brand modal-bottom modal-reload-success"
        isOpen={isReloadSuccess}
        toggle={() => {
          setIsReloadSuccess(false);
        }}
        centered
      >
        <ModalBody>
          <div className="text-center">
            <strong className="reload-title text-yellow mb-3 d-block">
              {t("RELOAD_SUCCESS")}
            </strong>
            <div className="text-brand text-bo">
              {t("PAID_DEPOSIT", { amount: paidAmount })}
            </div>
          </div>
          <table className="table text-brand table-reload-detail">
            <tr>
              <th>{t("DEPOSIT_DATE_TIME")}</th>
              <th style={{ textAlign: "right" }}>{reloadDate}</th>
            </tr>
            <tr>
              <th>{t("REFERENCE_NUMBER")}</th>
              <th style={{ textAlign: "right" }}>{transcactionNumber}</th>
            </tr>
          </table>
          <button
            className="custom-btn-style-1"
            onClick={() => {
              handleModalOnClick();
            }}
          >
            {t("DONE")}
          </button>
        </ModalBody>
      </Modal>
    </>
  );
};

export default TNGDeposit;
